export const setScrollbarWidth = () => {
/** https://destroytoday.com/blog/100vw-and-the-horizontal-overflow-you-probably-didnt-know-about */
  let scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${scrollBarWidth}px`
  );
}



// WEBPACK FOOTER //
// ./app/javascript/lib/scrollbar.js